import React, { useEffect, useState } from 'react'
import './Online_table.css'
import { DatePicker, Input } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getOnlineTable } from '../../../actions/arrival_flights.action'
import moment from 'moment';
import { formatMonth } from '../../formatMonth';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import PageHeader from '../../page-header/PageHeader';
import { API_URI } from '../../../axios';
import { Helmet } from 'react-helmet';
import { CloseButton } from 'react-bootstrap';

const Online_table = ({ visible }) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const language = i18next.language
    const [active, setActive] = useState(1)
    const [type, setType] = useState('1')
    const [search, setSearch] = useState('')
    const [query, setQuery] = useState('')
    const [date, setDate] = useState(new Date())


    const fetchData = () => {

        let params = {
            flight_type: active === 1 ? 'departures' : 'arrivals',
            query,
            date: moment(date).format("YYYY-MM-DD")
        }
        dispatch(getOnlineTable(language, params))
    }



    useEffect(() => {

        // const interval = setInterval(() => {
        let params = {
            flight_type: active === 1 ? 'departures' : 'arrivals',
            query,
            date: moment(date).format("YYYY-MM-DD")
        }
        console.log(params)
        dispatch(getOnlineTable(language, params))

        // }, 5000);


        // return () =>clearInterval(interval)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [language, type, active, date, query]);

    const arrival_flights = useSelector(state => state.arrival_flights.arrival_flights)

    const yesterday = () => {
        let d = new Date(date);
        d.setDate(d.getDate() - 1);
        setDate(d)
    }

    const tomorrow = () => {
        let d = new Date(date);
        d.setDate(d.getDate() + 1);
        setDate(d)
    }

    // const formatDate = () => {
    //     const date = new Date().toISOString()
    //     const month = date.split("T")[0].split("-")[1]
    //     return `${formatMonth(month, language)} ${moment(date).format(`DD, YYYY`)}`
    // }

    const checkStatus = (status) => {
        if (active === 1)
            switch (Number(status)) {
                case 0 : return {
                    name: t("departed"),
                    color: "#ff0000",
                };
                case 1: return {
                    name: t("boarding_closed"),
                    color: ""
                };
                case 2: return {
                    name: t("cancelled"),
                    color: "#ff0000"
                };
                case 3: return {
                    name: t("checkin"),
                    color: "#0A940B"
                };
                case 4: return {
                    name: t("checkin_closed"),
                    color: "#ff0000"
                };
                case 5: return {
                    name: t("delayed"),
                    color: "gray"
                };
                case 6: return {
                    name: t("on_time"),
                    color: "gray"
                };
                default: return ''
            }
        else if (active === 2)
            switch (Number(status)) {
                case 0: return {
                    name: t("landed"),
                    color: "#0A940B",
                };
                case 1: return {
                    name: t("cancelled"),
                    color: "#ff0000"
                };
                case 2: return {
                    name: t("delayed"),
                    color: ""
                };
                case 3: return {
                    name: t("on_time"),
                    color: ""
                };
                default: return ''
            }
    }

    return (
        <>
            <>
                <Helmet>
                    <title>{`${t("online_table")} - ${t("Ashgabat_International_Airport")}`}</title>
                </Helmet>
                <PageHeader
                    title={t("online_table")}
                    breadCrumbItems={[
                        { label: t("home"), path: '/' },
                        { label: t("online_table"), path: '#' }
                    ]}
                />
                {<div className="container flex flex-col pt-4 pb-16" id='onlayn_table'>
                    <div className='w-full bg-white rounded-md py-2 mx-auto shadow-md mt-4'>
                        <div className='min-[600px]:overflow-x-auto max-[600px]:overflow-x-hidden'>
                            <div className='flex gap-3 justify-center align-center my-4'>
                                <div className={`flex cursor-pointer gap-2 items-center rounded-md border-1 py-0.5 px-4 transition-all border-[#0A940B] text-[#0A940B] ${active === 1 ? 'active-button' : ''}`} onClick={() => active === 2 && setActive(1)}>
                                    <img src='/assets/images/arrival.svg' />
                                    <div>{t("departure")}</div>
                                </div>
                                <div className={`flex cursor-pointer gap-2 items-center rounded-md border-1 py-0.5 px-4 transition-all border-[#0A940B] text-[#0A940B] ${active === 2 ? 'active-button' : ''}`} onClick={() => active === 1 && setActive(2)}>
                                    <img src='/assets/images/departure.svg' />
                                    <div>{t("arrival")}</div>
                                </div>
                            </div>
                            <div className='flex justify-between items-center gap-3 max-[1024px]:flex-col m-2 mb-3'>
                                <div className='flex items-center border-1 rounded-md py-2 max-[425px]:flex-col max-[425px]:gap-3'>
                                    <div onClick={() => yesterday()} className='flex cursor-pointer items-center gap-1 text-[#0A940B] text-[15px] px-4 border-r max-[425px]:border-0'>
                                        <ChevronLeft />
                                        <div >{t("yesterday")}</div>
                                    </div>
                                    <div className=' flex text-center justify-end items-center gap-1 font-medium text-[15px] px-4 border-r max-[425px]:border-0 relative'>
                                        <DatePicker className='text-center' placeholder={`${moment(date).format("DD")} ${formatMonth((moment(date).format("MM")), language)}`} value={''} onChange={(e) => setDate(e._d)} />
                                    </div>
                                    <div onClick={() => tomorrow()} className='flex cursor-pointer items-center gap-1 text-[#0A940B] text-[15px] px-4'>
                                        <div >{t("tomorrow")}</div>
                                        <ChevronRight />
                                    </div>
                                </div>
                                <div className='relative w-[50%] max-[600px]:w-full'>
                                    <Input value={search} onChange={(e) => setSearch(e?.currentTarget?.value)} placeholder={`${t("search_placeholder")} ...`} />
                                    <div className='right-1 close-search top-0 bottom-0 my-auto absolute flex gap-1 items-center'>
                                        <div onClick={() => { setSearch(''); setQuery('') }} className={`bg-[#F1F1F1] cursor-pointer rounded-[5px]  w-[30px] h-[30px] flex justify-center items-center ${search !== '' ? '' : 'hidden'}`}>
                                            <CloseButton className='w-[10px] h-[10px] text-[10px]' />
                                        </div>
                                        <div onClick={() => setQuery(search)} className='bg-[#F1F1F1] cursor-pointer rounded-[5px]  w-[30px] h-[30px] flex justify-center items-center'>
                                            <img src='/assets/images/search.svg' />
                                        </div>
                                    </div>
                                </div>
                                <div onClick={() => { fetchData() }} id='refresh' className='refresh-button flex cursor-pointer items-center gap-1 text-[#0A940B] text-[15px] px-2 border-1 rounded-md py-1'>
                                    <img src='/assets/images/refresh.svg' />
                                    <div>{t("refresh")}</div>

                                </div>
                                {/* </div> */}
                            </div>
                            <div className=""></div>
                            <table className="max-[600px]:hidden table p-2 min-w-[1000px]">
                                <tbody>
                                    <tr>
                                        <td className=' !bg-[rgba(0,0,0,0.25)]'>{t("airline")}</td>
                                        <td className=' !bg-[rgba(0,0,0,0.25)]'>{t("flight")}</td>
                                        <td className=' !bg-[rgba(0,0,0,0.25)]'>{t("direction")}</td>
                                        <td className=' !bg-[rgba(0,0,0,0.25)]'>{t("departure")}</td>
                                        <td className=' !bg-[rgba(0,0,0,0.25)]'>{t("terminal")}</td>
                                        <td className=' !bg-[rgba(0,0,0,0.25)]'>{t("status")}</td>
                                    </tr>
                                    {
                                        arrival_flights.length ? arrival_flights.map((item, i) => (
                                            <>
                                            {i % 2 === 0 ?
                                            <tr key={item.id} className=''>
                                            <td className='px-2 py-3'> <img style={{ height: '35px' }} src={`${API_URI}${item.airline.logo}`} alt="" /></td>
                                            <td className='p-2'><span className='!font-bold uppercase'> {item.flight_number}</span> <br/> {item.airline.name}</td>
                                            <td className='p-2'>{active === 1 ? item.destination_city : item?.departure_city}</td>
                                            <td className='p-2'>{active === 1 ? moment(item.departure_time_actual).format("HH : mm") : moment(item.arrival_time_actual).format("HH : mm")}</td>
                                            <td className='p-2'>{item?.terminal?.name}</td>
                                            <td className='p-2' style={{color: checkStatus(item.status_code).color}}> {checkStatus(item.status_code).name}</td>
                                        </tr>
                                             :
                                             <tr key={item.id} className=''>
                                                <td className='px-2 py-3 !bg-[#F1F1F1]'> <img style={{ height: '35px' }} src={`${API_URI}${item.airline.logo}`} alt="" /></td>
                                                <td className='p-2 !bg-[#F1F1F1]'><span className='!font-bold uppercase'> {item.flight_number}</span> <br/> {item.airline.name}</td>
                                                <td className='p-2 !bg-[#F1F1F1]'>{active === 1 ? item.destination_city : item?.departure_city}</td>
                                                <td className='p-2 !bg-[#F1F1F1]'>{active === 1 ? moment(item.departure_time_actual).format("HH : mm") : moment(item.arrival_time_actual).format("HH : mm")}</td>
                                                <td className='p-2 !bg-[#F1F1F1]'>{item?.terminal?.name}</td>
                                                <td className='p-2 !bg-[#F1F1F1]' style={{color: checkStatus(item.status_code).color}}> {checkStatus(item.status_code).name}</td>
                                            </tr>
                                             }
                                            </>
                                        )) : <tr><td colSpan={5} className='text-center'>{t("nothing_found")}</td></tr>
                                    }
                                </tbody>
                            </table>
                            <div className='hidden max-[600px]:flex max-[600px]:flex-col m-3 mb-0  overflow-hidden'>
                                {
                                    arrival_flights.length ? arrival_flights.map(item => (
                                        <div key={item.id} style={{ boxShadow: "0px 4px 10px 0px #0000000D" }} className=' w-full mb-3'>
                                            <div className='flex justify-between items-center'>
                                                <div className='p-2'>{active === 1 ? moment(item.departure_time_actual).format("HH : mm") : moment(item.arrival_time_actual).format("HH : mm")}</div>
                                                <div className='p-2'>{item?.terminal?.name}</div>
                                            </div>
                                            <div className='flex justify-between items-center'>
                                                <div className='p-2'>{active === 1 ? item.destination_city : item?.departure_city}</div>
                                                <div className='p-2'> <img style={{ height: '23px' }} src={`${API_URI}${item.airline.logo}`} alt="" /> </div>
                                            </div>
                                            <div className='p-2'>{item.flight_number} {item.airline.name}</div>

                                        </div>
                                    )) : <div className='w-full text-center'>{t("nothing_found")}</div>
                                }
                            </div>
                        </div>
                        <div className='flex items-center border-1 rounded-md py-2 max-[425px]:flex-col max-[425px]:gap-3'>
                            <div onClick={() => yesterday()} className='flex cursor-pointer items-center gap-1 text-[#0A940B] text-[15px] px-4 border-r max-[425px]:border-0'>
                                <ChevronLeft />
                                <div >{t("yesterday")}</div>
                            </div>
                            <div className=' flex text-center justify-end items-center gap-1 font-medium text-[15px] px-4 border-r max-[425px]:border-0 relative'>
                                {/* <div className='capitalize absolute top-0 bottom-0 left-0 right-0 m-auto'>{moment(date).format("DD")} {formatMonth((moment(date).format("MM")), language)} {moment(date).format("YYYY")}</div> */}
                                <DatePicker className='text-center' placeholder={`${moment(date).format("DD")} ${formatMonth((moment(date).format("MM")), language)}`} value={''} onChange={(e) => setDate(e._d)} />
                            </div>
                            <div onClick={() => tomorrow()} className='flex cursor-pointer items-center gap-1 text-[#0A940B] text-[15px] px-4'>
                                <div >{t("tomorrow")}</div>
                                <ChevronRight />
                            </div>
                        </div>
                    </div>
                </div>}
            </>
        </>
    )
}

export default Online_table